import { Lozenge } from 'shared/lozenge/Lozenge';
import { tokens } from 'styles/tokens';

export type Axis = 'X' | 'Y' | 'Z';

export type AxesEnabledDisplayProps = {
    enabledAxes: Axis[];
};

export function AxesEnabledDisplay({ enabledAxes }: AxesEnabledDisplayProps) {
    return (
        <div className="flex gap-4">
            {enabledAxes.length === 0 && <div>None</div>}
            {enabledAxes.map((axis) => (
                <Lozenge
                    key={axis}
                    backgroundColor={tokens.lozenge.greenBackground}
                    color={tokens.text.onColor}
                >
                    {axis}
                </Lozenge>
            ))}
        </div>
    );
}
